const getCtaAfterSubmissionFormDataLocalStorageKey = require("./getCtaAfterSubmissionFormDataLocalStorageKey");

/**
 * @param formData {Object}
 * @return {void}
 */
module.exports = function saveCtaAfterSubmissionFormData(formData) {
    const localStorageKey = getCtaAfterSubmissionFormDataLocalStorageKey();

    window.localStorage.setItem(localStorageKey, JSON.stringify(formData));
}